<template>
  <div class="statistics" v-loading="loading">
    <div class="statistics-first">
      <div
        class="statistics-first-list"
        v-for="(item, index) in 3"
        :key="index"
      >
        <img
          class="statistics-first-list-left"
          :src="
            index == 0
              ? require('../../assets/user/user-statistics-total.png')
              : index == 1
              ? require('../../assets/user/user-statistics-general.png')
              : require('../../assets/user/user-statistics-vip.png')
          "
        />
        <div class="statistics-first-list-right">
          <div class="list-right-title">
            {{
              index == 0
                ? '总用户（人）'
                : index == 1
                ? '普通用户（人）'
                : index == 2
                ? 'VIP用户（人）'
                : ''
            }}
          </div>
          <div class="list-right-num">
            {{
              index == 0
                ? volumeObj.userNum
                : index == 1
                ? volumeObj.ptUserNum
                : volumeObj.vipUserNum
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="statistics-second">
      <div class="statistics-second-block">
        <div class="second-block-left">用户每日新增数据</div>
        <div class="second-block-right">
          <el-date-picker
            v-model="pitchMonth"
            type="month"
            placeholder="选择月"
            @change="numpeopleBtn"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </div>
      </div>

      <div class="statistics-second-daily">
        <div class="daily-left">
          <div
            id="dailyChart"
            style="width: 7.395833rem; height: 1.59375rem"
          ></div>
        </div>
        <div class="daily-right">
          <div
            class="daily-right-block"
            v-for="(item, index) in 2"
            :key="index"
          >
            <div class="daily-right-block-title">
              {{
                index == 0
                  ? '昨日新增（人）'
                  : index == 1
                  ? '今日新增（人）'
                  : ''
              }}
            </div>

            <div class="daily-right-block-num">
              {{
                index == 0 ? userNewlyObj.yesterdayNum : userNewlyObj.todayNum
              }}
            </div>

            <div class="daily-right-block-comparison" v-if="index == 1">
              <img
                class="comparison-img"
                :src="
                  riseShow == true
                    ? require('../../assets/user/user-rise.png')
                    : require('../../assets/user/user-fall.png')
                "
              />
              <div class="comparison-percent">
                {{ userPercentage > 0 ? userPercentage : 0 }}%
              </div>
              <div class="comparison-npercent">同比昨日</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="statistics-three">
      <div class="statistics-second-block">
        <div class="second-block-left">用户每日活跃数据</div>
        <div class="second-block-right">
          <el-date-picker
            v-model="activeMonth"
            type="month"
            placeholder="选择月"
            value-format="yyyy-MM"
            @change="activeMonthBtn"
          >
          </el-date-picker>
        </div>
      </div>

      <div class="statistics-second-daily">
        <div class="daily-left">
          <div
            id="activeChart"
            style="width: 7.395833rem; height: 1.59375rem"
          ></div>
        </div>
        <div class="daily-right">
          <div
            class="daily-right-block"
            v-for="(item, index) in 2"
            :key="index"
          >
            <div class="daily-right-block-title">
              {{
                index == 0
                  ? '昨日活跃（人）'
                  : index == 1
                  ? '今日活跃（人）'
                  : ''
              }}
            </div>

            <div class="daily-right-block-num">
              {{
                index == 0
                  ? activeNewlyObj.yesterdayNum
                  : activeNewlyObj.todayNum
              }}
            </div>
            <div class="daily-right-block-comparison" v-if="index == 1">
              <img
                class="comparison-img"
                :src="
                  activeriseShow == true
                    ? require('../../assets/user/user-rise.png')
                    : require('../../assets/user/user-fall.png')
                "
              />
              <div class="comparison-percent">
                {{ activePercentage > 0 ? activePercentage : 0 }}%
              </div>
              <div class="comparison-npercent">同比昨日</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus'
import { getDateTime } from '../../utils/time' // 时间戳转化
import { getStatistics, getuserMonth } from '../../api/user'

export default {
  comments() {},
  data() {
    return {
      // 第一区域  用户量
      volumeObj: {},
      // 第二区域 获取选中月份
      pitchMonth: '',
      // 第二区域 用户每日新增数据 对象
      userNewlyObj: {},
      // 第二区域 判断是否涨还是跌
      riseShow: Boolean,
      // 第二区域 上涨百分比
      userPercentage: 0,

      // 第三区域 获取选中月份
      activeMonth: '',
      // 第三区域 用户每日新增数据 对象
      activeNewlyObj: {},
      // 第三区域 判断是否涨还是跌
      activeriseShow: Boolean,
      // 第三区域 上涨百分比
      activePercentage: 0,
      // 监听用户刷新
      loading: false,
    }
  },
  created() {
    this.loading = true
    // 第二区域 每日新增人数 获取月份
    this.pitchMonth = getDateTime('month')
    // 第三区域 获取当前月份
    this.activeMonth = getDateTime('month')
    // 获取 基础信息
    this.getDatabasics()
    // 获取 每日新增活跃人数 以及 新增人数 1新增 2活跃
    this.getDynamicNewly(1)
    this.getDynamicNewly(0)
  },
  mounted() {},
  methods: {
    // 获取统计表基础信息
    getDatabasics() {
      let params = {}

      getStatistics(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('获取接口返回', res)
          // 获取 用户数量对象
          this.volumeObj = res.resultData
          this.loading = false
        }
      })
    },
    // 第二区域 点击获取月份
    numpeopleBtn(val) {
      if (val) {
        var year = val.split('-')[0]
        var month = val.split('-')[1]
        this.pitchMonth = year + '-' + month
        // 触发 月份
        this.getDynamicNewly(1)
      }
    },
    // 第三区域  点击获取对应月份
    activeMonthBtn(val) {
      if (val) {
        var year = val.split('-')[0]
        var month = val.split('-')[1]
        this.activeMonth = year + '-' + month
        // 触发 月份
        this.getDynamicNewly(0)
      }
    },
    // 获取每日新增活跃人数 以及 新增人数
    getDynamicNewly(index) {
      let params = {
        month: index == 1 ? this.pitchMonth : this.activeMonth,
        type: index,
      }

      getuserMonth(params).then((res) => {
        if (res.resultStatus == true) {
          if (index == 1) {
            this.userNewlyObj = res.resultData
            console.log('获取对象', this.userNewlyObj)
            // 今日新增人数
            let todayNum = Number(res.resultData.todayNum)
            // 昨日新增人数
            let yesterdayNum = Number(res.resultData.yesterdayNum)

            // 开始获取百分比 同比昨日
            // 先获取今日是否比昨日多
            this.riseShow = todayNum - yesterdayNum >= 0 ? true : false
            //   // 获取上下涨幅百分比
            this.userPercentage = Number(res.resultData.addUserRate)
            // 获取日期数组 / yesterdayNum
            let userNewly = res.resultData.statisticsList
            // 当前月份时间日期
            let userTime = []
            // 当前月份新增人数新增
            let userPeople = []
            userNewly.forEach((item, index) => {
              userTime.push(item.time.slice(-2))
              userPeople.push(item.num)
            })
            console.log('获取日期数组', userTime)
            console.log('获取人数新增数组', userPeople)

            this.$nextTick(() => {
              // 第二区域折线图
              this.getnewDaily(userTime, userPeople)
            })
          } else {
            this.activeNewlyObj = res.resultData
            console.log('获取对象', this.activeNewlyObj)
            // 今日新增人数
            let todayNum = Number(res.resultData.todayNum)
            // 昨日新增人数
            let yesterdayNum = Number(res.resultData.yesterdayNum)

            // 开始获取百分比 同比昨日
            // 先获取今日是否比昨日多
            this.activeriseShow = todayNum - yesterdayNum >= 0 ? true : false
            //   // 获取上下涨幅百分比
            this.activePercentage = Number(res.resultData.addUserRate)

            // 获取日期数组
            let userNewly = res.resultData.statisticsList
            // 当前月份时间日期
            let userTime = []
            // 当前月份新增人数新增
            let userPeople = []
            userNewly.forEach((item, index) => {
              userTime.push(item.time.slice(-2))
              userPeople.push(item.num)
            })
            console.log('获取日期数组', userTime)
            console.log('获取人数新增数组', userPeople)
            this.$nextTick(() => {
              // 第二区域折线图
              this.getnewActive(userTime, userPeople)
            })
          }
        }
      })
    },
    // 第二区域折线图
    getnewDaily(time, people) {
      var myChart = this.$echarts.init(document.getElementById('dailyChart'))
      // 绘制图表
      myChart.setOption(
        {
          tooltip: {
            trigger: 'axis',
          },
          calculable: true,
          xAxis: [
            {
              name: '日期',
              type: 'category',
              boundaryGap: false,
              data: time,
              axisLine: {
                show: true,
                // 坐标轴线
                lineStyle: {
                  color: '#999999',
                },
              },
              axisTick: {
                //刻度线
                show: false,
                lineStyle: {
                  color: '#999999',
                },
              },
            },
          ],
          grid: {
            left: '4%',
            right: '4%',
            top: '60px',
            bottom: '20%',
          },
          yAxis: [
            {
              name: '人',
              type: 'value',
              axisLabel: {
                formatter: '{value}',
              },
              splitLine: {
                show: false, //不显示分隔线
              },
              minInterval: 1,
            },
          ],
          color: ['#DCE7FC'],
          series: [
            {
              symbol: 'none',
              name: '新增(人)',
              type: 'line',
              color: ['#29D647'],
              smooth: true,
              data: people,
              itemStyle: {
                normal: {
                  color: '#29D647',
                  lineStyle: {
                    width: 3, //设置线条粗细
                    shadowOffsetX: 0, // 折线的X偏移
                    shadowColor: 'rgba(41, 214, 71, 1)', //折线颜色
                  },
                },
              },
            },
          ],
        },
        true
      )
    },
    // 第三区域折线图
    getnewActive(time, people) {
      var myChart = this.$echarts.init(document.getElementById('activeChart'))
      // 绘制图表
      myChart.setOption(
        {
          tooltip: {
            trigger: 'axis',
          },
          calculable: true,
          xAxis: [
            {
              name: '日期',
              type: 'category',
              boundaryGap: false,
              data: time,
              axisLine: {
                show: true,
                // 坐标轴线
                lineStyle: {
                  color: '#999999',
                },
              },
              axisTick: {
                //刻度线
                show: false,
                lineStyle: {
                  color: '#999999',
                },
              },
            },
          ],
          grid: {
            left: '4%',
            right: '4%',
            top: '60px',
            bottom: '20%',
          },
          yAxis: [
            {
              name: '人',
              type: 'value',
              axisLabel: {
                formatter: '{value}',
              },
              splitLine: {
                show: false, //不显示分隔线
              },
              minInterval: 1,
            },
          ],
          color: ['#DCE7FC'],
          series: [
            {
              symbol: 'none',
              name: '活跃(人)',
              type: 'line',
              color: ['#29D647'],
              smooth: true,
              data: people,
              itemStyle: {
                normal: {
                  color: '#29D647',
                  lineStyle: {
                    width: 3, //设置线条粗细
                    shadowOffsetX: 0, // 折线的X偏移
                    shadowColor: 'rgba(41, 214, 71, 1)', //折线颜色
                  },
                },
              },
            },
          ],
        },
        true
      )
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: #dcdfe6;
}

.statistics {
  .statistics-first {
    height: 100px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .statistics-first-list {
      width: 252px;
      height: 72px;
      display: flex;
      align-items: center;

      .statistics-first-list-left {
        width: 72px;
        height: 72px;
      }

      .statistics-first-list-right {
        margin-left: 16px;
        .list-right-title {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          line-height: 20px;
        }

        .list-right-num {
          height: 28px;
          font-size: 24px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #222222;
          line-height: 28px;
          margin-top: 4px;
        }
      }
    }
  }

  .statistics-second,
  .statistics-three {
    margin-top: 24px;
    width: 100%;
    background: #ffffff;
    padding: 0 24px;
    padding-bottom: 40px;
    box-sizing: border-box;

    .statistics-second-block {
      width: 100%;
      height: 74px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .second-block-left {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 25px;
      }

      .second-block-right {
        width: 180px;
        height: 40px;
        background: #ffffff;
        border-radius: 2px;

        /deep/ .el-date-editor.el-input {
          width: 180px;
        }

        /deep/ .el-input--prefix .el-input__inner {
          padding-left: 50px;
        }

        /deep/ .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
    }

    .statistics-second-daily {
      width: 100%;
      height: 306px;
      display: flex;
      justify-content: space-between;

      .daily-left {
        width: 1420px !important;
        height: 100%;
      }

      .daily-right {
        margin-right: 32px;
        margin-top: 48px;

        .daily-right-block {
          margin-top: 34px;

          .daily-right-block-title {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999;
            line-height: 20px;
          }
          .daily-right-block-num {
            height: 28px;
            font-size: 24px;
            font-weight: bold;
            color: #222222;
            line-height: 28px;
            text-align: left;
            margin-top: 8px;
          }

          .daily-right-block-comparison {
            display: flex;
            align-items: center;
            height: 17px;
            margin-top: 6px;
            .comparison-img {
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }
            .comparison-percent {
              font-size: 16px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: #222222;
              margin-right: 6px;
            }
            .comparison-npercent {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(34, 34, 34, 0.35);
            }
          }
        }
      }
    }
  }
}
</style>
